import parsePhoneNumberFromString from "libphonenumber-js/min";
export { isValidPhoneNumber } from "libphonenumber-js/min";

export const formatToE164 = (value: string) => {
  const phoneNumber = parsePhoneNumberFromString(value, "US");

  if (phoneNumber) {
    return phoneNumber.format("E.164");
  }

  return value;
};

export const formatPhoneNumber = (value: string | null) => {
  if (value == null) return null;

  const stringValue = value.toString();

  const phoneNumber = parsePhoneNumberFromString(stringValue, "US");

  if (phoneNumber) {
    return `+${phoneNumber.countryCallingCode}${phoneNumber.formatNational()}`;
  }

  return value;
};
